module.exports = __webpack_public_path__ + "img/back.e43d1d1c.png";